[
  {
    "id": "GET-M7P-L204-001",
    "module": "Getalbegrip",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Een laptop kost € 480. In de uitverkoop krijg je eerst 25% korting, en daarna nog eens 10% extra korting op de nieuwe prijs. Wat betaal je?",
    "options": ["€ 324", "€ 312", "€ 336", "€ 360"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "korting_meerstaps",
    "familyId": "GET-PROC-KORTING-ACHTERELKAAR",
    "conceptId": "successive_percentage_discounts",
    "variantIndex": 1,
    "explanation": "Stap 1: 25% korting op € 480.\n25% = 1/4, dus € 480 ÷ 4 = € 120 korting.\nNieuwe prijs: € 480 − € 120 = € 360.\n\nStap 2: 10% korting op € 360.\n10% = € 36.\nEindprijs: € 360 − € 36 = € 324.",
    "distractorExplanations": {
      "1": "Je hebt 25% en 10% bij elkaar opgeteld (35%) en dat in één keer van € 480 afgehaald. Maar bij twee kortingen achter elkaar gaat de tweede korting over de al verlaagde prijs, niet over het beginbedrag.",
      "2": "Je hebt de 10% korting waarschijnlijk van het oorspronkelijke bedrag (€ 480) genomen: 10% daarvan is € 48. Maar de 10% hoort bij de nieuwe prijs (€ 360), dus dat is € 36.",
      "3": "Dit is de prijs na alleen de eerste korting (25%). Je mist nog de tweede stap: 10% van € 360 eraf."
    }
  },
  {
    "id": "GET-M7P-L204-002",
    "module": "Getalbegrip",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Reken uit: $\\frac{2}{3}$ + $\\frac{1}{6}$ =",
    "options": ["$\\frac{5}{6}$", "$\\frac{3}{9}$", "$\\frac{3}{6}$", "$\\frac{1}{2}$"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "optellen_ongelijknamig",
    "familyId": "GET-BREUK-OPTELLEN-ONGELIJKNAMIG",
    "conceptId": "add_fractions_unlike_denominators",
    "variantIndex": 1,
    "explanation": "Maak de noemers gelijk.\nHet kleinste gemeenschappelijke veelvoud van 3 en 6 is 6.\n$\\frac{2}{3} = \\frac{4}{6}$.\nDan: $\\frac{4}{6} + \\frac{1}{6} = \\frac{5}{6}$.",
    "distractorExplanations": {
      "1": "Hier tel je teller én noemer op (2+1 en 3+6). Dat is een veelgemaakte fout: je mag breuken alleen optellen als je eerst gelijknamig maakt.",
      "2": "Dit lijkt alsof je 2/3 hebt ‘omgezet’ naar 2/6 (alleen de noemer veranderd). Maar als je de noemer ×2 doet, moet de teller ook ×2: 2/3 wordt 4/6, niet 2/6.",
      "3": "Je hebt waarschijnlijk afgerond naar ‘ongeveer een half’. Maar $\\frac{2}{3}$ is al groter dan $\\frac{1}{2}$, dus met $\\frac{1}{6}$ erbij moet de uitkomst zeker groter zijn dan $\\frac{1}{2}$."
    }
  },
  {
    "id": "GET-M7P-L204-003",
    "module": "Getalbegrip",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "De verhouding jongens : meisjes is 2 : 3. Er zijn 15 meisjes. Hoeveel jongens zijn er?",
    "options": ["10", "6", "9", "12"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhouding_terugrekenen",
    "familyId": "GET-VERH-DELEN-GEGEVEN-DEELVINDEN",
    "conceptId": "ratio_find_other_part_given_one_part",
    "variantIndex": 1,
    "explanation": "De 3 bij meisjes betekent: meisjes zijn 3 gelijke delen.\n15 meisjes = 3 delen → 15 ÷ 3 = 5 per deel.\nJongens zijn 2 delen → 2 × 5 = 10 jongens.",
    "distractorExplanations": {
      "1": "Je hebt waarschijnlijk alle delen bij elkaar genomen (2+3=5) en iets met 15 gedaan. Maar 15 hoort alleen bij de 3 delen van de meisjes; je moet eerst uitrekenen hoeveel 1 deel is.",
      "2": "Je hebt mogelijk 15 gedeeld door 2 gedaan (alsof 15 bij jongens hoort) of je hebt de verhouding omgedraaid. Let op: 15 is het aantal meisjes, dus dat hoort bij de ‘3’.",
      "3": "Je zit dicht in de buurt maar je hebt een stap overgeslagen of afgerond. Controleer via delen: 15 ÷ 3 = 5 (niet 6). Daarna 2 × 5 = 10."
    }
  },
  {
    "id": "GET-M7P-L204-004",
    "module": "Getalbegrip",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Wat is 1% van 2.500?",
    "options": ["25", "2,5", "250", "0,25"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "percentage_1_procent",
    "familyId": "GET-PROC-1PCT-VAN-GETAL",
    "conceptId": "one_percent_of_number",
    "variantIndex": 1,
    "explanation": "1% betekent: delen door 100.\n$2.500 \\div 100 = 25$.\nDus 1% van 2.500 is 25.",
    "distractorExplanations": {
      "1": "2,5 is 0,1% van 2.500 (delen door 1.000). Voor 1% deel je door 100: 25.",
      "2": "250 is 10% van 2.500 (delen door 10). 1% is nog een factor 10 kleiner: 25.",
      "3": "0,25 is 0,01% van 2.500 (delen door 10.000). Je bent twee stappen te ver gegaan."
    }
  },
  {
    "id": "GET-M7P-L204-005",
    "module": "Getalbegrip",
    "difficulty": 204,
    "difficultyTier": 10,
    "levelCode": "M7+",
    "group": 7,
    "question": "Reken uit: 12 $\\times$ 0,5 =",
    "options": ["6", "24", "12,5", "60"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "vermenigvuldigen_met_halve",
    "familyId": "GET-DEC-KEER-0P5-HALVEREN",
    "conceptId": "multiply_by_half",
    "variantIndex": 1,
    "explanation": "0,5 is hetzelfde als $\\frac{1}{2}$.\nVermenigvuldigen met 0,5 betekent dus: de helft nemen.\nDe helft van 12 is 6.",
    "distractorExplanations": {
      "1": "24 krijg je als je ‘keer 2’ doet. Dat gebeurt vaak als 0,5 wordt gezien als ‘groter maken’, maar 0,5 is kleiner dan 1: het maakt het getal juist kleiner.",
      "2": "12,5 zou passen als je 12 deelt door 0,96-achtig of als je de komma ‘eraan plakt’. Maar 12 × 0,5 is exact de helft: 6.",
      "3": "60 ontstaat als je 12 × 5 doet en de komma vergeet. Denk: 0,5 = een halve, dus het antwoord moet kleiner zijn dan 12 (niet groter)."
    }
  }
]
